
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    contactSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className="bg-white/95 backdrop-blur-sm border-b border-[#D96B33]/20 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/f13d1435349aeb632c8499ee5bedeb50/a89402d92b7e9437ddd544d2c10f506d.png" 
              alt="Yepes Web Lab Logo" 
              className="w-12 h-12"
            />
            <span className="text-2xl font-bold text-[#182114]" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
              Yepes Web Lab
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className="text-[#2E3F25] hover:text-[#D96B33] transition-colors duration-300 font-medium cursor-pointer"
              style={{ fontFamily: '"Century Gothic", sans-serif' }}
            >
              Home
            </Link>
            
            {/* Services Dropdown */}
            <div 
              className="relative"
              onMouseEnter={() => setIsServicesOpen(true)}
              onMouseLeave={() => setIsServicesOpen(false)}
            >
              <button 
                className="text-[#D96B33] font-semibold flex items-center gap-1 cursor-pointer"
                style={{ fontFamily: '"Century Gothic", sans-serif' }}
              >
                Services
                <i className={`ri-arrow-down-s-line transition-transform duration-300 ${isServicesOpen ? 'rotate-180' : ''}`}></i>
              </button>
              
              {/* Dropdown Menu */}
              <div className={`absolute top-full left-0 mt-2 w-64 bg-white rounded-2xl shadow-xl border border-gray-100 transition-all duration-300 ${isServicesOpen ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-2'}`}>
                <div className="py-4">
                  <Link 
                    to="/web-design-development"
                    className="block px-6 py-4 text-[#182114] hover:text-[#D96B33] hover:bg-gray-50 transition-colors duration-300 font-medium cursor-pointer"
                    style={{ fontFamily: '"Century Gothic", sans-serif' }}
                  >
                    Web Design & Development
                  </Link>
                  <Link 
                    to="/automation-ai-integrations"
                    className="block px-6 py-4 text-[#D96B33] hover:bg-gray-50 transition-colors duration-300 font-medium cursor-pointer"
                    style={{ fontFamily: '"Century Gothic", sans-serif' }}
                  >
                    Automation & AI
                  </Link>
                  <Link 
                    to="/qa-testing-services"
                    className="block px-6 py-4 text-[#182114] hover:text-[#D96B33] hover:bg-gray-50 transition-colors duration-300 font-medium cursor-pointer"
                    style={{ fontFamily: '"Century Gothic", sans-serif' }}
                  >
                    QA & Testing Services
                  </Link>
                  <Link 
                    to="/branding-digital-strategy"
                    className="block px-6 py-4 text-[#182114] hover:text-[#D96B33] hover:bg-gray-50 transition-colors duration-300 font-medium cursor-pointer"
                    style={{ fontFamily: '"Century Gothic", sans-serif' }}
                  >
                    Branding & Digital Strategy
                  </Link>
                </div>
              </div>
            </div>

            <button 
              onClick={scrollToContact}
              className="bg-[#D96B33] text-white px-6 py-3 rounded-full hover:bg-[#B85A2B] transition-colors duration-300 font-semibold whitespace-nowrap cursor-pointer"
              style={{ fontFamily: '"Century Gothic", sans-serif' }}
            >
              Get Started
            </button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-[#182114]`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/" 
                className="text-[#2E3F25] hover:text-[#D96B33] transition-colors duration-300 font-medium cursor-pointer"
                style={{ fontFamily: '"Century Gothic", sans-serif' }}
              >
                Home
              </Link>
              
              <div className="space-y-2">
                <div className="text-[#D96B33] font-semibold" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
                  Services
                </div>
                <div className="pl-4 space-y-2">
                  <Link 
                    to="/web-design-development"
                    className="block py-3 text-[#182114] hover:text-[#D96B33] transition-colors duration-300 font-medium cursor-pointer"
                    style={{ fontFamily: '"Century Gothic", sans-serif' }}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Web Design & Development
                  </Link>
                  <Link 
                    to="/automation-ai-integrations"
                    className="block py-3 text-[#D96B33] transition-colors duration-300 font-medium cursor-pointer"
                    style={{ fontFamily: '"Century Gothic", sans-serif' }}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Automation & AI
                  </Link>
                  <Link 
                    to="/qa-testing-services"
                    className="block py-3 text-[#182114] hover:text-[#D96B33] transition-colors duration-300 font-medium cursor-pointer"
                    style={{ fontFamily: '"Century Gothic", sans-serif' }}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    QA & Testing Services
                  </Link>
                  <Link 
                    to="/branding-digital-strategy"
                    className="block py-3 text-[#182114] hover:text-[#D96B33] transition-colors duration-300 font-medium cursor-pointer"
                    style={{ fontFamily: '"Century Gothic", sans-serif' }}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Branding & Digital Strategy
                  </Link>
                </div>
              </div>
              
              <button 
                onClick={scrollToContact}
                className="bg-[#D96B33] text-white px-6 py-3 rounded-full hover:bg-[#B85A2B] transition-colors duration-300 font-semibold text-center whitespace-nowrap cursor-pointer"
                style={{ fontFamily: '"Century Gothic", sans-serif' }}
              >
                Get Started
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
